import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="adv-search"
export default class extends Controller {
  connect() {
    const modal = document.querySelector('.advanced-search-modal');
    const content = document.querySelector('.advanced-search-modal__content');
    modal.addEventListener('click', (e) => {
      if(e.target !== content){
        modal.classList.remove('open');
      }
    })
  }

  open() {
    const modal = document.querySelector('.advanced-search-modal');
    modal.classList.add('open');
  }

  close() {
    const modal = document.querySelector('.advanced-search-modal');
    modal.classList.remove('open');
  }
}
